export const LOCATION_FIELDS = [
  {
    key: 'businessName',
    label: 'Business Name',
    // placeholder: 'Acme Corp',
    type: 'text',
    layout: 'grid',
    validators: ['required'],
  },

  {
    key: 'email',
    label: 'Email Address',
    // placeholder: 'john@acme.com',
    type: 'email',
    layout: 'grid',
    validators: ['required', 'email'],
    // disabledWhen: values => values.emailLocked,
  },
  {
    key: 'firstName',
    label: 'First Name',
    // placeholder: 'John',
    type: 'text',
    layout: 'grid',
    validators: ['required', 'alphaName'],
  },
  {
    key: 'lastName',
    label: 'Last Name',
    // placeholder: 'Doe',
    type: 'text',
    layout: 'grid',
    validators: ['required', 'alphaName'],
  },

  {
    key: 'mobile',
    label: 'Mobile Number',
    // placeholder: '(555) 987-6543',
    type: 'tel',
    layout: 'grid',
    maxLength: 18,
    validators: ['required', 'phone'],
  },
  {
    key: 'salesforceEmail',
    label: 'Salesforce Primary Contact Email',
    // placeholder: 'sf@acme.com',
    type: 'email',
    layout: 'grid',
    validators: ['email'],
  },

  {
    key: 'address',
    label: 'Customer Address',
    // placeholder: '123 Main St',
    type: 'text',
    layout: 'grid',
    section: 'address',
    validators: ['required'],
  },
  {
    key: 'city',
    label: 'City',
    // placeholder: 'Dallas',
    type: 'text',
    layout: 'grid',
    section: 'address',
    validators: ['required'],
  },

  {
    key: 'state',
    label: 'State',
    type: 'select',
    layout: 'grid',
    validators: ['required'],
    // dependsOn: 'country',
    // optionsApi: values => `/states?country=${values.country}`,
    // optionsKey: 'states',
    // disabledWhen: account => !account?.country,
  },
  {
    key: 'country',
    label: 'Country',
    type: 'select',
    layout: 'grid',
    validators: ['required'],
  },
  {
    key: 'postCode',
    label: 'Postal Code',
    // placeholder: '75201',
    type: 'text',
    layout: 'grid',
    section: 'address',
    validators: ['required', 'postalCode'],
  },
  {
    key: 'leadId',
    label: 'Lead ID',
    // placeholder: 'Lead ID',
    type: 'text',
    layout: 'grid',
    // validators: ['required'],
  },
  {
    key: 'abn',
    label: 'Australian Business Number (ABN)',
    // placeholder: 'ABN',
    type: 'text',
    layout: 'grid',
    // parentOnly: true,
    validators: ['required', 'abn'],
    infoLink: 'https://abr.business.gov.au/',
    infoLinkLabel: 'ABN Lookup',
    // visibleWhen: account => account?.country === 'AU',
  },
  {
    key: 'nzbn',
    label: 'New Zealand Business Number (NZBN)',
    // placeholder: 'NZBN',
    type: 'text',
    layout: 'grid',
    infoLink: 'https://www.nzbn.govt.nz/',
    infoLinkLabel: 'NZBN Lookup',
    // parentOnly: true,
    validators: ['nzbn'],
    // visibleWhen: account => account?.country === 'NZ',
  },

  // BUSREQ-14451: generic optional tax identifier for international countries. No
  // format validation by design (no validators). Visibility: locationFieldRules.js.
  {
    key: 'taxId',
    label: 'Tax ID / VAT / GST Number',
    type: 'text',
    layout: 'grid',
  },

  // ── Location (parent + child) ──────────────────────────────────────────────
  {
    key: 'locationName',
    label: 'Location Name',
    // placeholder: 'Acme Corp - Downtown - West Side',
    type: 'text',
    layout: 'full',
    // visibleWhen: account =>
    //   account?.transactionType === 'single-location' ||
    //   (account?.transactionType === 'multiple-locations' &&
    //     !(account?.type === 'parent')),
  },

  // ── Sales attribution + billing (two columns) ──────────────────────────────
  // Two-column block: the LEFT column stacks the sales question, its dependent
  // input (Search by Name / XP Code) and the SST override question; the RIGHT
  // column stacks Business Phone then Bill To beside them (filling the space next
  // to the question). Explicit column pinning keeps this alignment regardless of
  // which conditional fields show.
  {
    key: 'salesRepOrPartner',
    label: 'Is this sale on behalf of another Sales or Partner?',
    type: 'toggle',
    layout: 'left',
    default: 'no',
    // optionsKey: 'salesRepOrPartnerOptions',
    // options: [
    //   {value: 'salesrep', label: 'Sales Rep'},
    //   {value: 'partner', label: 'Partner'},
    //   {value: 'no', label: 'No'},
    // ],
  },

  {
    key: 'salesRepInfo',
    label: 'Search by Name',
    // placeholder: 'Search by Name',
    type: 'async-search',
    layout: 'left',
    validators: ['required'],
    // searchApi: query => `/sales-reps?q=${query}`,
    // visibleWhen: account => account?.values?.salesRep === 'sales-rep',
  },

  {
    key: 'xpCode',
    label: 'Search Partner',
    placeholder: 'XP Code',
    type: 'xp-code-search',
    layout: 'left',
    validators: ['required'],
  },

  {
    key: 'telephone',
    label: 'Business Phone',
    // placeholder: '(555) 123-4567',
    type: 'tel',
    layout: 'right',
    maxLength: 18,
    validators: ['required', 'phone'],
  },

  {
    key: 'billTo',
    label: 'Bill To',
    type: 'toggle',
    layout: 'right',
    default: 'parent',
    options: [
      {value: 'parent', label: 'Parent Pay'},
      {value: 'self', label: 'Self'},
    ],
    validators: ['required'],
  },

  {
    key: 'overrideSST',
    label: 'Do you want to override SST on this order?',
    type: 'toggle',
    layout: 'left',
    default: 'no',
    // optionsKey: 'overrideSSTOptions',
    // options: [
    //   {value: 'yes', label: 'Yes'},
    //   {value: 'no', label: 'No'},
    // ],
  },

  {
    key: 'overrideRepInfo',
    label: 'Search by Name',
    // placeholder: 'Search by Name',
    type: 'async-search',
    layout: 'left',
    validators: ['required'],
    // searchApi: query => `/sales-reps?q=${query}`,
    // visibleWhen: account => account?.values?.salesRep === 'sales-rep',
  },

  // FULSAS-11921: Admin-only flag. Visibility controlled in locationFieldRules.js.
  {
    key: 'internalAccount',
    label: 'Internal Account',
    type: 'checkbox',
    layout: 'full',
    default: false,
  },
]

// Fields that remain visible in the "Create Purchase Link" (order) flow. Everything
// else in LOCATION_FIELDS (the identity/address/billTo block) is hidden so the rep only
// confirms sales attribution + SST before proceeding to the order. Defined as a keep-list
// (hide-by-complement) so any future identity/address field is hidden automatically.
export const ORDER_FLOW_VISIBLE_FIELD_KEYS = [
  'salesRepOrPartner',
  'salesRepInfo',
  'xpCode',
  'overrideSST',
  'overrideRepInfo',
]

export function emptyLocation(verifiedEmail) {
  return LOCATION_FIELDS.reduce((acc, field) => {
    if (field.key === 'email') {
      acc[field.key] = verifiedEmail ?? ''
    } else {
      acc[field.key] = field.default ?? ''
    }
    return acc
  }, {})
}
